// modules
import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import DocumentTitle from 'react-document-title';
import styled from 'styled-components';
// styles
import '../Dashboard/index.css';
// components
import CourseNavigation from '../Dashboard/CourseNavigation';
import MenuNavigation from './MenuNavigation';
import ExternalAccessCourse from './Course';
// redux

const StyledNavigationContainer = styled.div`
    background-image: ${(props) => `url(${props.background})`};
    background-position: top;
    background-repeat: repeat-y;
    background-size: auto 100vh;
`;

const StyledContentContainer = styled.div`
    background-color: ${(props) => props.color};
`;

class ExternalAccess extends Component {
    render() {
        const { currentCourse, t } = this.props;

        const leftPanelBackground =
            (currentCourse &&
                currentCourse.courseStyle &&
                currentCourse.courseStyle.leftPanelBackground) ||
            'none';
        const rightPanelBackground =
            (currentCourse &&
                currentCourse.courseStyle &&
                currentCourse.courseStyle.rightPanelBackground) ||
            'none';
        const contentBackgroundColor =
            (currentCourse &&
                currentCourse.courseStyle &&
                currentCourse.courseStyle.contentBackgroundColor) ||
            '#ffffff';

        return (
            <DocumentTitle title={t('dashboard.externalAccess.title')}>
                <div className='dashboard'>
                    <StyledNavigationContainer className='course-navigation' background={leftPanelBackground} >
                        <CourseNavigation />
                    </StyledNavigationContainer>
                    <StyledContentContainer
                        className='content'
                        color={contentBackgroundColor}
                    >
                        <Switch>
                            <Route path='/external-access/courses/:courseId' component={ExternalAccessCourse} />
                            <Redirect to='/' />
                        </Switch>
                    </StyledContentContainer>
                    <StyledNavigationContainer
                        className='menu-navigation'
                        background={rightPanelBackground}
                    >
                        <MenuNavigation />
                    </StyledNavigationContainer>

                    <div className='mobile-navigation'>
                        <CourseNavigation />
                        <MenuNavigation />
                    </div>
                </div>
            </DocumentTitle>
        );
    }
}


const mapStateToProps = (state) => ({
    currentCourse: state.ui.currentCourse,
});

export default compose(
    connect(mapStateToProps, null),
    withTranslation(),
)(ExternalAccess);
